// DR runtime config — populated from AWS account 225683022030, us-west-2
// after the dr-workflow-svcs and dr-portal-stack created the underlying
// Cognito pool, API Gateway, and CloudFront distribution.
const Config = {
  StackName: "dr-doc-analyzer",
  DefaultImageName: "default_document_3.png",
  CognitoIdentityPoolId: "us-west-2:5999b74c-daad-49bf-a20d-9e3263ae23a1",
  CognitoUserPoolId: "us-west-2_AaAYCjIty",
  DeployRegion: "us-west-2",
  CognitoId: "cognito-idp.us-west-2.amazonaws.com/us-west-2_AaAYCjIty",
  APIUrl: "https://e7sblvtfvj.execute-api.us-west-2.amazonaws.com/prod",
  LogoutUrl:
    "https://dr-vanguard-platform-dr.auth.us-west-2.amazoncognito.com/logout?client_id=ktgg3etrkgjoq3bt0pm64ai0k&logout_uri=https://portal.dr.vg.spsglobal.com&redirect_uri=https://portal.dr.vg.spsglobal.com&response_type=token",
  LoginUrl:
    "https://dr-vanguard-platform-dr.auth.us-west-2.amazoncognito.com/login?client_id=ktgg3etrkgjoq3bt0pm64ai0k&response_type=token&scope=aws.cognito.signin.user.admin+email+openid+phone+profile&redirect_uri=https://portal.dr.vg.spsglobal.com",
  ChatExternalLink: "https://www.google.com",
  TicketExternalLink: null,
  AnalyticsExternalLink: "https://reports.dr.vg.spsglobal.com/",
  OperatorHubExternalLink: "/operator-hub/",
  TicketTableColumns: {
    ticket: { visible: true },
    title: { visible: true },
    subject: { visible: true },
    status: { visible: true },
    docClass: { visible: true },
    lob: { visible: true },
    created: { visible: true },
    checkNumber: { visible: false, hideIfEmpty: true },
    checkType: { visible: false, hideIfEmpty: true },
    checkAmount: { visible: false, hideIfEmpty: true },
    comments: { visible: true },
    view: { visible: true },
    action: { visible: true },
  },
};

export default Config;
